// Componentes compartilhados de aviso de duplicidade.
// Extraídos do LoteRowsTable pra também serem usados na tela manual (Nova/Editar Entrega).
// fev/2026 (v4.1)
import { AlertTriangle, Ban } from "lucide-react";
import { STATUS } from "@/lib/api";

// Chip visual pro status da entrega duplicada (usado dentro do DupCallout).
export function StatusChip({ status }) {
  const cls = {
    aguardando: "bg-amber-500 text-white",
    em_transito: "bg-blue-600 text-white",
    concluida: "bg-emerald-600 text-white",
    remarcar: "bg-orange-500 text-white",
    cancelada: "bg-slate-500 text-white",
  }[status] || "bg-slate-400 text-white";
  const label = STATUS[status] || status || "?";
  return (
    <span className={`inline-block px-1.5 py-0.5 rounded text-[10px] font-bold uppercase mono ${cls}`}>
      {label}
    </span>
  );
}

// Callout de duplicidade — box vermelho (blocking) ou âmbar (warn-only).
// Props: dup = { blocking, matches: [{number, source, status, cliente, entrega_data, same_date}] } | null
// fev/2026 (v5): matches podem vir de outras datas (janela de 30d) — o callout
// exibe "cadastrada em DD/MM/YYYY" pra deixar claro pro operador se é do mesmo
// dia ou de dias anteriores.
export function DupCallout({ dup, testId }) {
  if (!dup) return null;
  const { blocking, matches } = dup;
  const wrapCls = blocking ? "bg-rose-50 border-rose-400" : "bg-amber-50 border-amber-400";
  const headingCls = blocking ? "text-rose-800" : "text-amber-800";
  const HeadIcon = blocking ? Ban : AlertTriangle;
  const heading = blocking
    ? "TRAVADO — corrija antes de salvar"
    : "ATENÇÃO — pode salvar mesmo assim";
  const fmtBR = (iso) => {
    if (!iso || typeof iso !== "string" || iso.length < 10) return null;
    const [y, m, d] = iso.slice(0, 10).split("-");
    return `${d}/${m}/${y}`;
  };
  return (
    <div className={`mt-2 rounded-lg border-2 p-2.5 ${wrapCls}`} data-testid={testId}>
      <div className={`flex items-center gap-1.5 font-extrabold uppercase text-xs tracking-wide ${headingCls}`}>
        <HeadIcon className="w-4 h-4 shrink-0" />
        <span>{heading}</span>
      </div>
      <ul className="mt-1.5 space-y-1 text-xs text-slate-800">
        {matches.map((m, idx) => {
          const dataLabel = m.source === "db" ? fmtBR(m.entrega_data) : null;
          return (
            <li key={`${m.source}-${m.number}-${m.entrega_id || idx}`} className="flex flex-wrap items-center gap-1.5" data-testid={`${testId}-item-${idx}`}>
              <span className="mono font-extrabold text-sm">Nº {m.number}</span>
              <span>—</span>
              <span>
                {m.source === "lote" ? "está em outra linha do lote" : "já cadastrada no sistema"}
              </span>
              <StatusChip status={m.status} />
              {dataLabel && (
                <span
                  className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${m.same_date ? "bg-slate-200 text-slate-700" : "bg-indigo-100 text-indigo-800"}`}
                  data-testid={`${testId}-item-${idx}-date`}
                >
                  {m.same_date ? "MESMA DATA" : `EM ${dataLabel}`}
                </span>
              )}
              {m.cliente && (
                <span className="text-[10px] text-slate-600 italic">({m.cliente})</span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
